import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import { AppComfirmComponent } from './app-confirm.component';

interface confirmData {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

@Injectable()
export class AppConfirmService {

  constructor(private dialog: MatDialog) { }

  public confirm(data: confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Confirm';
    data.message = data.message || 'Are you sure?';
    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: '520px',
      maxWidth: '92vw',
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'app-confirm-dialog',
      data: {
        title: data.title,
        message: data.message,
        confirmText: data.confirmText || 'SI',
        cancelText: data.cancelText || 'NO'
      }
    });
    return dialogRef.afterClosed();
  }
}
